// Модалка не нуждается в styler
/* eslint-disable styler/check-styler */

import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { ModalDesktop as Modal } from '@alfalab/core-components-modal/desktop';
import { Stack } from '@alfa-bank/site-stack';

import { ModalV2 as Component } from '../modal-v2';
import type { TModalV2Desktop, IDeps } from '../models';

import styles from './desktop.css';

export const ModalV2Desktop = createWidget<IDeps, TModalV2Desktop>({
    Modal,
    Stack,
    styles,
})(Component);
